import Toastr from "../../../itrust_common/components/Toastr"

const DEFAULT_STATE = {
  reports: [],
  report: {},
  editing: false,
  meta: { pagination: {} },
  saving: false,
}

let changes = null;
export default function previousReportReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  switch (action.type) {
    // case 'PREVIOUS_REPORTS_LOAD_PENDING':
    //   return { ...state, saving: true };

    case 'PREVIOUS_REPORTS_LOAD_REJECTED':
    case 'PREVIOUS_REPORT_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'PREVIOUS_REPORTS_LOAD_FULFILLED':
      changes = { ...response, saving: false };
      return { ...state, ...changes };

    case 'PREVIOUS_REPORT_LOAD_FULFILLED':
      changes = { report: response.report, saving: false }
      return { ...state, ...changes };

    default:
      return state;
  }
}